import { Component, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { BusinessInfoComponent } from './business-info/business-info.component';
import { CompareComponent } from './compare/compare.component';
import { FinancialInfoComponent } from './financial-info/financial-info.component';
import { InputGeneralApplicationComponent } from './input-general-application/input-general-application.component';
import { SelectGeneralApplicationComponent } from './select-general-application/select-general-application.component';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { ApplicationStepperComponent } from 'app/components/application-stepper/application-stepper.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@Component({
    selector: 'corporate-screen',
    templateUrl: './corporate-screen.component.html',
    styleUrls: ['./corporate-screen.component.scss'],
    imports: [
        HeaderComponent,
        FooterComponent,
        InputGeneralApplicationComponent,
        SelectGeneralApplicationComponent,
        FormsModule,
        ReactiveFormsModule,
        CompareComponent,
        FinancialInfoComponent,
        BusinessInfoComponent,
        TranslateModule,
        CommonModule,
        MatDividerModule,
        ApplicationStepperComponent,
        MatExpansionModule,
        MatCardModule,
        SlickCarouselModule,
    ],
    standalone: true,
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
})
export class CorporateScreenComponent {
    isAuthenticated: boolean = false;
    clickedOutside: boolean = false;
    clickedOutsideDD: boolean = false;
    productName: string;

    value = 20;
    panelOpenState = signal(true);
    currentSlide: number = 0;
    slideConfig = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
    };

    rightSide = [
        {
            title: 'RIGHT_DIV.TITLE_1',
            subtitle: 'RIGHT_DIV.SUBTITLE_1',
        },
        {
            title: 'RIGHT_DIV.TITLE_2',
            subtitle: 'RIGHT_DIV.SUBTITLE_2',
        },
        {
            title: 'RIGHT_DIV.TITLE_3',
            subtitle: 'RIGHT_DIV.SUBTITLE_3',
        },
    ];

    constructor(private router: Router) {
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
        this.productName =
            this.router.getCurrentNavigation()?.extras?.state?.productName;
    }

    ngOnInit(): void {
        if (this.isAuthenticated == false) {
            this.router.navigate(['/login']);
        }
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    mainCloseDropDown() {
        this.clickedOutsideDD = !this.clickedOutsideDD;
    }

    afterChange(e) {
        this.currentSlide = e.currentSlide;
    }

    beforeChange(e) {
        this.currentSlide = e.currentSlide;
    }
}
